export class WellKnownCourseCategories {
  static readonly students: string = "131646500";
}
